

// import React, { useState, useEffect } from "react";
// import axios from "axios";

// export default function UserCreate() {
//   const [users, setUsers] = useState([]);
//   const [input, setInput] = useState({ name: "", email: "", password: "", mobile: "", permissions: [] });
//   const [editingId, setEditingId] = useState(null);
//   const [createdBy, setCreatedBy] = useState(null);
//   const [creatEmail, setCreateEmail] = useState('');



//     const [permissions, setPermissions] = useState([]);
//     const [userName, setUserName] = useState('User Name');
//     const [userImage, setUserImage] = useState(null);
//     const [userRole, setUserRole] = useState(null);
//     const [showAppointment, setShowAppointment] = useState(false);
//     const [showTemplates, setShowTemplates] = useState(true);


//   useEffect(() => {
//     const stored = sessionStorage.getItem("user");
//     if (stored) {
//       const u = JSON.parse(stored);
//       setUserName(u.name || "User");
//       setUserImage(u.image || null);
//       setUserRole(u.role || null);

//       if (u.role === "member") {
//         try {
//           const perms = typeof u.permissions === "string" ? JSON.parse(u.permissions) : u.permissions;
//           setPermissions(perms.map(p => p.toLowerCase())); // convert to lowercase for easy matching
//         } catch (err) {
//           console.error("Invalid permissions format", err);
//           setPermissions([]);
//         }
//       }

//       if (u.email === "vckumar555@gmail.com") {
//         setShowAppointment(true);
//       }
//     }
//   }, []);



//   const menuItems = [
//     { path: '/dashboard', icon: 'fa-tachometer-alt', label: 'Dashboard' },
//     {
//       path: '/message-templates',
//       icon: 'fa-envelope',
//       label: 'Message Templates',
//       children: [
//         ...(showTemplates ? [{ path: '/message-templates', label: 'Templates' }] : []),
//         ...(showAppointment ? [
//           { path: '/appointment', label: 'PP Appointment' },
//           { path: '/message-templates/us-visa-appointment', label: 'US Visa Appointment' },
//           { path: '/message-templates/labour-license', label: 'Labour License' },
//           { path: '/message-templates/trade-license', label: 'Trade License' },
//           { path: '/message-templates/birthday-greetings', label: 'Birthday Greetings' },
//           { path: '/message-templates/festival-greetings', label: 'Festival Greetings' },
//         ] : []),
//       ]
//     },
//     {
//       path: '/singlecontacts', icon: 'fa-address-book', label: 'Contacts',
//       children: [
//         { path: '/singlecontacts', label: 'Single contact' },
//         { path: '/Add-new', label: 'Group contact' },
//       ]
//     },
//     {
//       path: '/', icon: 'fa-table', label: 'Table Config',
//       children: [
//         { path: '/table-create', label: 'Table create' },
//         { path: '/usertables-list', label: 'User tables list' },
//       ]
//     },
//     {
//       path: '/', icon: 'fa-clipboard', label: 'Bot Config',
//       children: [
//         { path: '/template-Form', label: 'Template Mapping' },
//         { path: '/template-list', label: 'Template Mapping List' },
//       ]
//     },
//     {
//       path: '/', icon: 'fa-list', label: 'Column Mapping',
//       children: [
//         { path: '/column-mapping', label: 'Column Mapping' },
//         { path: '/language', label: 'Language' },
//       ]
//     },
//     {
//        path: '/', icon: 'fa-list', label: 'UserCreation',
//         children: [
//           {path: '/userCreate', label: 'Create a User'},
//         ]
//     }
//   ];




//   useEffect(() => {
//     fetchUsers();
//     const user = JSON.parse(sessionStorage.getItem("user"));
//     if (user) 
//       setCreatedBy(user.id);
//     setCreateEmail(user.email);
//   }, []);

//   const fetchUsers = () => {
//     axios.get("https://botapi.emedha.in/pages/api/users").then(res => setUsers(res.data));
//   };

//   const handleParentCheckbox = (parent) => {
//     const childLabels = parent.children?.map(c => c.label) || [];
//     let updated = [...input.permissions];

//     const allSelected = childLabels.every(c => updated.includes(c));
//     if (allSelected) {
//       // uncheck all children
//       updated = updated.filter(p => !childLabels.includes(p));
//     } else {
//       // add all children
//       updated = Array.from(new Set([...updated, ...childLabels]));
//     }

//     setInput({ ...input, permissions: updated });
//   };

//   const handleChildCheckbox = (childLabel) => {
//     let updated = [...input.permissions];
//     if (updated.includes(childLabel)) {
//       updated = updated.filter(p => p !== childLabel);
//     } else {
//       updated.push(childLabel);
//     }
//     setInput({ ...input, permissions: updated });
//   };

//   const handleSubmit = () => {
//     const body = { ...input, createdBy,creatEmail, permissions: JSON.stringify(input.permissions) };

//     if (editingId === null) {
//       axios.post("https://botapi.emedha.in/pages/api/users", body).then(() => { fetchUsers(); clearForm(); });
//     } else {
//       axios.put(`https://botapi.emedha.in/pages/api/users/${editingId}`, body).then(() => { fetchUsers(); clearForm(); setEditingId(null); });
//     }
//   };

//   const clearForm = () => setInput({ name: "", email: "", password: "", mobile: "", permissions: [] });

//   const handleEdit = (user) => {
//     setEditingId(user.id);
//     setInput({
//       name: user.name,
//       email: user.email,
//       password: user.password,
//       mobile: user.mobile,
//       permissions: JSON.parse(user.permissions || "[]")
//     });
//   };

//   const handleDelete = (id) => axios.delete(`https://botapi.emedha.in/pages/api/users/${id}`).then(() => fetchUsers());

//   return (
//     <div style={{ padding: 20 }}>
//       <h2>User Creation (With Permissions)</h2>

//       <div style={{ background: "#fff", padding: 20, borderRadius: 10, width: "60%" }}>
//         <input placeholder="Name" value={input.name} onChange={(e) => setInput({ ...input, name: e.target.value })} className="form-control mb-2" />
//         <input placeholder="Email" value={input.email} onChange={(e) => setInput({ ...input, email: e.target.value })} className="form-control mb-2" />
//         <input placeholder="Password" value={input.password} onChange={(e) => setInput({ ...input, password: e.target.value })} className="form-control mb-2" />
//         <input placeholder="Mobile" value={input.mobile} onChange={(e) => setInput({ ...input, mobile: e.target.value })} className="form-control mb-2" />

//         <h5>Permissions:</h5>
//         <div style={{ display: "flex", flexDirection: "column" }}>
//           {menuItems.map((menu, idx) => (
//             <div key={idx} style={{ marginBottom: 10 }}>
//               {menu.children ? (
//                 <>
//                   <label>
//                     <input
//                       type="checkbox"
//                       checked={menu.children.every(c => input.permissions.includes(c.label))}
//                       onChange={() => handleParentCheckbox(menu)}
//                     />{" "}
//                     {menu.label}
//                   </label>
//                   <div style={{ paddingLeft: 20, display: "flex", flexDirection: "column" }}>
//                     {menu.children.map((child, cidx) => (
//                       <label key={cidx}>
//                         <input
//                           type="checkbox"
//                           checked={input.permissions.includes(child.label)}
//                           onChange={() => handleChildCheckbox(child.label)}
//                         />{" "}
//                         {child.label}
//                       </label>
//                     ))}
//                   </div>
//                 </>
//               ) : (
//                 <label>
//                   <input
//                     type="checkbox"
//                     checked={input.permissions.includes(menu.label)}
//                     onChange={() => handleChildCheckbox(menu.label)}
//                   />{" "}
//                   {menu.label}
//                 </label>
//               )}
//             </div>
//           ))}
//         </div>

//         <button className="btn btn-success mt-3" onClick={handleSubmit}>{editingId ? "Update User" : "Create User"}</button>
//       </div>

//       <h3 className="mt-4">User List</h3>
//       <table className="table table-bordered" style={{ background: "#fff" }}>
//         <thead>
//           <tr><th>Name</th><th>Email</th><th>Mobile</th><th>Permissions</th><th>Actions</th></tr>
//         </thead>
//         <tbody>
//           {users.map((u) => (
//             <tr key={u.id}>
//               <td>{u.name}</td>
//               <td>{u.email}</td>
//               <td>{u.mobile}</td>
//               <td>{JSON.parse(u.permissions || "[]").join(", ")}</td>
//               <td>
//                 <button className="btn btn-primary btn-sm" onClick={() => handleEdit(u)}>Edit</button>
//                 <button className="btn btn-danger btn-sm ms-2" onClick={() => handleDelete(u.id)}>Delete</button>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   );
// }















import React, { useState, useEffect } from "react";
import axios from "axios";
import { UserPlus, Edit3, Trash2, ChevronLeft, ChevronRight, ShieldCheck, Shield, User, CheckCircle, Info, } from "lucide-react";

// ─── Constants & Meta Definitions ───────────────────────────────────────────
const ROLES = [
  {
    key: "super_admin",
    label: "Super Admin",
    icon: <ShieldCheck size={16} />,
    color: "#6d28d9", // violet-700
    bg: "#f5f3ff",    // violet-50
    border: "#ddd6fe", // violet-200
    desc: "Full platform access — manages tables, templates, pricing, system configurations, and all users.",
  },
  {
    key: "client_admin",
    label: "Client Admin",
    icon: <Shield size={16} />,
    color: "#1d4ed8", // blue-700
    bg: "#eff6ff",    // blue-50
    border: "#bfdbfe", // blue-200
    desc: "Restricted to managing group contacts, sending messages, and viewing analytics.",
  },
  {
    key: "user",
    label: "Normal User",
    icon: <User size={16} />,
    color: "#047857", // emerald-700
    bg: "#ecfdf5",    // emerald-50
    border: "#a7f3d0", // emerald-200
    desc: "Can create tables and manage groups within assigned scope. No access to system config.",
  },
];

// const ALL_MODULES = [
//   { module: "Dashboard", items: [{ label: "Dashboard", key: "dashboard" }] },
//   { module: "Message Analytics", items: [{ label: "Message Analytics", key: "msg_analytics" }, { label: "Send Message", key: "send_message" }, { label: "Sent / Delivered / Read", key: "msg_history" }] },
//   { module: "Message Templates", items: [{ label: "Templates", key: "templates" }] },
//   { module: "Contacts", items: [{ label: "Upload Contact", key: "upload_contact" }, { label: "Contact List", key: "contact_list" }] },
//   { module: "Table Config", items: [{ label: "Create Table", key: "create_table" }, { label: "User Tables List", key: "tables_list" }] },
//   { module: "Bot Config", items: [{ label: "Template Mapping", key: "template_mapping" }, { label: "Template Mapping List", key: "mapping_list" }] },
//   { module: "Column Mapping", items: [{ label: "Column Mapping", key: "col_mapping" }, { label: "Language", key: "language" }] },
//   { module: "User Creation", items: [{ label: "Create a User", key: "create_user" }] },
//   { module: "Groups", items: [{ label: "Create Group", key: "create_group" }, { label: "Group Message", key: "group_message" }, { label: "Group Invite", key: "group_invite" }] },
  // { module: "Pricing & Billing", items: [{ label: "Pricing Plans", key: "pricing" }, { label: "Invoice History", key: "invoices" }] },
  // { module: "System Config", items: [{ label: "System Settings", key: "sys_settings" }, { label: "API Keys", key: "api_keys" }] },
// ];


const ALL_MODULES = [
  {
    module: "Dashboard",
    items: [
      { label: "Dashboard", key: "dashboard" }
    ]
  },
  {
    module: "Manage Contacts",
    items: [
      { label: "Add Groups", key: "add groups" },
      { label: "Add Contact", key: "add contact" },
      { label: "Contact List", key: "contact list" },
    ]
  },
  {
    module: "Send Message",
    items: [
      { label: "Send Message", key: "send message" }
    ]
  },
  {
    module: "Message Templates",
    items: [
      { label: "Templates", key: "templates" },
      { label: "PP Appointment", key: "pp appointment" },
      { label: "US Visa Appointment", key: "us visa appointment" },
      { label: "Labour License", key: "labour license" },
      { label: "Trade License", key: "trade license" },
      { label: "Birthday Greetings", key: "birthday greetings" },
      { label: "Festival Greetings", key: "festival greetings" },
    ]
  },
  {
    module: "Message Analytics",
    items: [
      { label: "Message Analytics", key: "message analytics" }
    ]
  },
  {
    module: "Table Config",
    items: [
      { label: "Table Create", key: "table create" },
      { label: "User Tables List", key: "user tables list" },
    ]
  },
  {
    module: "Bot Config",
    items: [
      { label: "Template Mapping", key: "template mapping" },
      { label: "Template Mapping List", key: "template mapping list" },
    ]
  },
  {
    module: "Column Mapping",
    items: [
      { label: "Column Mapping", key: "column mapping" },
      { label: "Language", key: "language" },
    ]
  },
  {
    module: "User Creation",
    items: [
      { label: "Create a User", key: "create a user" },
    ]
  },
  {
    module: "Groups",
    items: [
      { label: "CreateGroup", key: "creategroup" },
      { label: "Group Message", key: "group message" },
      { label: "Group Invite", key: "group invite" },
      { label: "GroupInfo", key: "groupinfo" },
    ]
  },
   { module: "Pricing & Billing", items: [{ label: "Pricing Plans", key: "pricing" }, { label: "Invoice History", key: "invoices" }] },
  { module: "System Config", items: [{ label: "System Settings", key: "sys_settings" }, { label: "API Keys", key: "api_keys" }] },

];

const ROLE_DEFAULTS = {
  super_admin: ALL_MODULES.flatMap((m) => m.items.map((i) => i.key)),
  client_admin: [
    "dashboard", "msg_analytics", "send_message", "msg_history",
    "upload_contact", "contact_list",
    "create_group", "group_message", "group_invite",
    "templates",
  ],
  user: [
    "dashboard",
    "send_message", "msg_history",
    "upload_contact", "contact_list",
    "create_table", "tables_list",
    "create_group", "group_message",
  ],
};

const ROLE_META = Object.fromEntries(ROLES.map((r) => [r.key, r]));
const allKeys = ALL_MODULES.flatMap((m) => m.items.map((i) => i.key));

// ─── Main Component ──────────────────────────────────────────────────────────

export default function CreateUser() {
  const [formData, setFormData] = useState({ name: "", email: "", mobile: "", password: "" });
  const [selectedRole, setSelectedRole] = useState("user");
  const [selectedPerms, setSelectedPerms] = useState(ROLE_DEFAULTS.user);
  const [users, setUsers] = useState([]);
  const [editingId, setEditingId] = useState(null);

  // Track operational session user scopes
  const [createdBy, setCreatedBy] = useState("");
  const [createEmail, setCreateEmail] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  // Track responsive screen width for dynamic styles
  const [windowWidth, setWindowWidth] = useState(typeof window !== "undefined" ? window.innerWidth : 1024);

  // Initialize and load base configurations
  useEffect(() => {
    fetchUsers();

    const user = JSON.parse(sessionStorage.getItem("user"));
    if (user) {
      setCreatedBy(user.id);
      setCreateEmail(user.email);
    }

    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobile = windowWidth < 640;
  const isTablet = windowWidth >= 640 && windowWidth < 1024;

  // ─── Data Access & Logic Actions ───────────────────────────────────────────

  const fetchUsers = () => {
    axios.get("https://botapi.emedha.in/pages/api/users")
      .then(res => setUsers(res.data))
      .catch(err => console.error("Error fetching users:", err));
  };

  const handleRoleChange = (role) => {
    setSelectedRole(role);
    setSelectedPerms(ROLE_DEFAULTS[role]);
  };

  const togglePerm = (key) => {
    setSelectedPerms((prev) =>
      prev.includes(key) ? prev.filter((p) => p !== key) : [...prev, key]
    );
  };

  const toggleAll = (keys, checked) => {
    if (checked) setSelectedPerms((prev) => [...new Set([...prev, ...keys])]);
    else setSelectedPerms((prev) => prev.filter((p) => !keys.includes(p)));
  };

  const clearForm = () => {
    setFormData({ name: "", email: "", password: "", mobile: "" });
    setSelectedRole("user");
    setSelectedPerms(ROLE_DEFAULTS.user);
  };

  const handleSubmit = (e) => {
    if (e) e.preventDefault();

    // Alert check if any fields are empty
    if (!formData.name || !formData.email || !formData.mobile || !formData.password) {
      alert("Please fill out all required fields marked with *");
      return;
    }

    // Package request body payload structure matching backend specification
    const body = {
      ...formData,
      role: selectedRole, // Properly sent down to database handler now
      createdBy,
      creatEmail: createEmail,
      permissions: JSON.stringify(selectedPerms)
    };

    if (editingId === null) {
      axios.post("https://botapi.emedha.in/pages/api/users", body)
        .then(() => {
          alert("🎉 Success: User created successfully!");
          fetchUsers();
          clearForm();
        })
        .catch(err => {
          console.error("Error creating user:", err);
          alert("❌ Error: Failed to create user.");
        });
    } else {
      axios.put(`https://botapi.emedha.in/pages/api/users/${editingId}`, body)
        .then(() => {
          alert("🔄 Success: User details updated successfully!");
          fetchUsers();
          clearForm();
          setEditingId(null);
        })
        .catch(err => {
          console.error("Error updating user:", err);
          alert("❌ Error: Failed to update user.");
        });
    }
  };


  const handleEdit = (user) => {
    setEditingId(user.id);
    setFormData({
      name: user.name,
      email: user.email,
      password: user.password || "",
      mobile: user.mobile
    });
    setSelectedRole(user.role || "user");
    setSelectedPerms(JSON.parse(user.permissions || "[]"));
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleDelete = (id) => {
    // Guard confirmation alert before erasing records
    if (window.confirm("Are you absolutely sure you want to delete this user?")) {
      axios.delete(`https://botapi.emedha.in/pages/api/users/${id}`)
        .then(() => {
          alert("🗑️ Success: User deleted successfully.");
          fetchUsers();
        })
        .catch(err => {
          console.error("Error deleting user:", err);
          alert("❌ Error: Failed to delete user.");
        });
    }
  };


  const handleCancel = () => {
    setEditingId(null);
    clearForm();
  };

  // Pagination management logic
  const totalPages = Math.ceil(users.length / itemsPerPage) || 1;
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentRows = users.slice(startIndex, startIndex + itemsPerPage);

  // ─── Inline Style Configuration Presets ────────────────────────────────────
  const theme = { fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif", primary: "#2563eb", primaryHover: "#1d4ed8", background: "#f8fafc", cardBg: "#ffffff", border: "#e2e8f0", textMain: "#0f172a", textMuted: "#64748b", destructive: "#dc2626", destructiveBg: "#fef2f2" };

  const styles = {
    wrapper: { fontFamily: theme.fontFamily, backgroundColor: theme.background, minHeight: "100vh", display: "flex", flexDirection: "column", gap: "24px", color: theme.textMain },
    header: { marginBottom: "8px" },
    title: { fontSize: "24px", fontWeight: "700", margin: "0 0 4px 0", display: "flex", alignItems: "center", gap: "8px" },
    subtitle: { fontSize: "14px", color: theme.textMuted, margin: 0 },
    grid3: { display: "grid", gridTemplateColumns: isMobile ? "1fr" : "repeat(3, 1fr)", gap: "12px" },
    roleExplainerCard: (role) => ({ backgroundColor: role.bg, border: `1px solid ${role.border}`, borderRadius: "12px", padding: "16px", }),
    cardHeader: { display: "flex", alignItems: "center", gap: "8px", marginBottom: "6px" },
    cardTitle: (color) => ({ fontSize: "14px", fontWeight: "700", color: color || theme.textMain, margin: 0 }),
    cardDesc: { fontSize: "12px", color: theme.textMuted, lineHeight: "1.5", margin: 0 },
    formCard: { backgroundColor: theme.cardBg, border: `1px solid ${theme.border}`, borderRadius: "12px", padding: "20px", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" },
    formCardTitle: { fontSize: "16px", fontWeight: "700", marginBottom: "16px", margin: "0 0 16px 0" },
    inputGrid: { display: "grid", gridTemplateColumns: isMobile ? "1fr" : isTablet ? "repeat(2, 1fr)" : "repeat(4, 1fr)", gap: "16px" },
    inputGroup: { display: "flex", flexDirection: "column", gap: "6px" },
    label: { fontSize: "12px", fontWeight: "600" },
    input: { padding: "10px 12px", fontSize: "14px", borderRadius: "8px", border: `1px solid ${theme.border}`, outline: "none", transition: "all 0.2s" },
    roleButton: (isActive, role) => ({ display: "flex", alignItems: "flex-start", gap: "12px", padding: "16px", borderRadius: "12px", border: isActive ? `2px solid ${role.border}` : `2px solid ${theme.border}`, backgroundColor: isActive ? role.bg : "transparent", textAlign: "left", cursor: "pointer", width: "100%", transition: "all 0.2s" }),
    infoBar: { marginTop: "12px", display: "flex", alignItems: "center", gap: "8px", padding: "8px 12px", borderRadius: "8px", backgroundColor: "#f1f5f9", border: `1px solid ${theme.border}` },
    matrixHeader: { display: "flex", justifyContent: "space-between", alignItems: "center", padding: "14px 20px", borderBottom: `1px solid ${theme.border}`, backgroundColor: "#f8fafc" },
    matrixRow: { padding: "14px 20px", borderBottom: `1px solid ${theme.border}`, display: "flex", flexDirection: "column", gap: "10px" },
    badge: (bgColor, textColor) => ({ fontSize: "10px", fontWeight: "600", padding: "2px 8px", borderRadius: "9999px", backgroundColor: bgColor, color: textColor }),
    pill: (checked) => ({ display: "inline-flex", alignItems: "center", gap: "6px", padding: "4px 10px", borderRadius: "8px", border: `1px solid ${checked ? "rgba(37,99,235,0.3)" : theme.border}`, fontSize: "12px", fontWeight: "500", cursor: "pointer", backgroundColor: checked ? "#eff6ff" : "#f8fafc", color: checked ? theme.primary : theme.textMuted }),
    footerBar: { padding: "12px 20px", backgroundColor: "#f8fafc", display: "flex", justifyContent: "space-between", alignItems: "center" },
    btnPrimary: { backgroundColor: theme.primary, color: "#fff", border: "none", borderRadius: "8px", padding: "8px 16px", fontSize: "13px", fontWeight: "600", cursor: "pointer", display: "flex", alignItems: "center", gap: "6px" },
    btnSecondary: { backgroundColor: "#fff", color: theme.textMain, border: `1px solid ${theme.border}`, borderRadius: "8px", padding: "8px 16px", fontSize: "13px", fontWeight: "600", cursor: "pointer" },
    table: { width: "100%", borderCollapse: "collapse", textAlign: "left", fontSize: "13px" },
    th: { padding: "12px 20px", backgroundColor: "#f8fafc", borderBottom: `1px solid ${theme.border}`, fontSize: "11px", fontWeight: "600", color: theme.textMuted, textTransform: "uppercase", letterSpacing: "0.05em" },
    td: { padding: "14px 20px", borderBottom: `1px solid ${theme.border}`, verticalAlign: "top" },
    actionBtn: () => ({ width: "28px", height: "28px", borderRadius: "8px", border: `1px solid ${theme.border}`, backgroundColor: "#fff", display: "inline-flex", alignItems: "center", justifyContent: "center", cursor: "pointer", color: theme.textMuted })
  };

  return (
    <div style={styles.wrapper}>
      {/* ── Page Wrapper Header ── */}
      <div style={styles.header}>
        <h1 style={styles.title}>
          <UserPlus size={22} style={{ color: theme.primary }} /> User Creation
        </h1>
        <p style={styles.subtitle}>Role-based access control — Super Admin, Client Admin, and Normal User</p>
      </div>

      {/* ── Role Architecture Explainer ── */}
      <div style={styles.grid3}>
        {ROLES.map((role) => (
          <div key={role.key} style={styles.roleExplainerCard(role)}>
            <div style={styles.cardHeader}>
              <span style={{ color: role.color, display: "flex" }}>{role.icon}</span>
              <p style={styles.cardTitle(role.color)}>{role.label}</p>
            </div>
            <p style={styles.cardDesc}>{role.desc}</p>
          </div>
        ))}
      </div>

      {/* ── User Details Input Form ── */}
      <form onSubmit={handleSubmit} style={styles.formCard}>
        <h2 style={styles.formCardTitle}> {editingId ? "Edit User Details" : "User Details"} </h2>
        <div style={styles.inputGrid}>
          {[
            { label: "Name", key: "name", type: "text", ph: "Enter name" },
            { label: "Email Address", key: "email", type: "email", ph: "user@emedha.com" },
            { label: "Mobile", key: "mobile", type: "text", ph: "+91 00000 00000" },
            { label: "Password", key: "password", type: "password", ph: "••••••••" },
          ].map(({ label, key, type, ph }) => (
            <div key={key} style={styles.inputGroup}>
              <label style={styles.label}>
                {label} <span style={{ color: theme.destructive }}>*</span>
              </label>
              <input
                type={type}
                placeholder={ph}
                value={formData[key]}
                onChange={(e) => setFormData({ ...formData, [key]: e.target.value })}
                style={styles.input}
                required
              />
            </div>
          ))}
        </div>
      </form>

      {/* ── Role Selector Form Section ── */}
      <div style={styles.formCard}>
        <h2 style={styles.formCardTitle}>Assign Role</h2>
        <div style={styles.grid3}>
          {ROLES.map((role) => {
            const isActive = selectedRole === role.key;
            return (
              <button key={role.key} type="button" onClick={() => handleRoleChange(role.key)} style={styles.roleButton(isActive, role)}>
                <span style={{ marginTop: "2px", flexShrink: 0, color: isActive ? role.color : theme.textMuted, display: "flex" }}>
                  {role.icon}
                </span>
                <div style={{ flexGrow: 1 }}>
                  <p style={{ fontSize: "14px", fontWeight: "700", margin: "0 0 4px 0", color: isActive ? role.color : theme.textMain }}>
                    {role.label}
                  </p>
                  <p style={styles.cardDesc}>{role.desc}</p>
                </div>
                {isActive && (
                  <CheckCircle size={14} style={{ marginLeft: "auto", flexShrink: 0, marginTop: "2px", color: role.color }} />
                )}
              </button>
            );
          })}
        </div>

        <div style={styles.infoBar}>
          <Info size={13} style={{ color: theme.textMuted, flexShrink: 0 }} />
          <p style={{ fontSize: "12px", color: theme.textMuted, margin: 0 }}>
            Role selection pre-fills permissions below. You can further customize individual access.
          </p>
        </div>
      </div>

      {/* ── Permission Matrix Panel ── */}
      <div style={{ ...styles.formCard, padding: 0, overflow: "hidden" }}>
        <div style={styles.matrixHeader}>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <ShieldCheck size={16} style={{ color: theme.primary }} />
            <p style={{ fontSize: "14px", fontWeight: "700", margin: 0 }}>Module Permissions</p>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: "8px", fontSize: "12px" }}>
            <button type="button" onClick={() => toggleAll(allKeys, true)} style={{ border: "none", background: "none", color: theme.primary, cursor: "pointer", fontWeight: "500" }}>
              Select All
            </button>
            <span style={{ color: theme.border }}>·</span>
            <button type="button" onClick={() => toggleAll(allKeys, false)} style={{ border: "none", background: "none", color: theme.textMuted, cursor: "pointer", fontWeight: "500" }}>
              Clear All
            </button>
          </div>
        </div>

        <div>
          {ALL_MODULES.map((mod) => {
            const modKeys = mod.items.map((i) => i.key);
            const allChecked = modKeys.every((k) => selectedPerms.includes(k));
            const someChecked = modKeys.some((k) => selectedPerms.includes(k));

            return (
              <div key={mod.module} style={styles.matrixRow}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <label style={{ display: "flex", alignItems: "center", gap: "10px", cursor: "pointer" }}>
                    <input
                      type="checkbox"
                      checked={allChecked}
                      ref={(el) => { if (el) el.indeterminate = someChecked && !allChecked; }}
                      onChange={(e) => toggleAll(modKeys, e.target.checked)}
                      style={{ width: "14px", height: "14px" }}
                    />
                    <span style={{ fontSize: "12px", fontWeight: "700", textTransform: "uppercase", letterSpacing: "0.05em" }}>{mod.module}</span>
                  </label>
                  <span style={styles.badge(allChecked ? "#e6f4ea" : someChecked ? "#fef3c7" : "#f1f5f9", allChecked ? "#137333" : someChecked ? "#b45309" : theme.textMuted)}>
                    {modKeys.filter((k) => selectedPerms.includes(k)).length}/{modKeys.length}
                  </span>
                </div>

                <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", paddingLeft: "24px" }}>
                  {mod.items.map((item) => {
                    const checked = selectedPerms.includes(item.key);
                    return (
                      <label key={item.key} style={styles.pill(checked)}>
                        <input type="checkbox" checked={checked} onChange={() => togglePerm(item.key)} style={{ width: "12px", height: "12px" }} />
                        {item.label}
                      </label>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>

        <div style={styles.footerBar}>
          <p style={{ fontSize: "12px", color: theme.textMuted, margin: 0 }}>
            <span style={{ fontWeight: "600", color: theme.textMain }}>{selectedPerms.length}</span> of {allKeys.length} permissions selected
          </p>
          <div style={{ display: "flex", gap: "8px" }}>
            <button type="button" onClick={handleSubmit} style={styles.btnPrimary}>
              <UserPlus size={14} /> {editingId ? "Update User" : "Create User"}
            </button>
            {editingId && (
              <button type="button" onClick={handleCancel} style={styles.btnSecondary}>Cancel</button>
            )}
          </div>
        </div>
      </div>

      {/* ── User Directory Section ── */}
      {/* <div style={{ ...styles.formCard, padding: 0, overflow: "hidden" }}>
        <div style={styles.matrixHeader}>
          <p style={{ fontSize: "14px", fontWeight: "700", margin: 0 }}>User Directory</p>
          <span style={styles.badge("#f1f5f9", theme.textMuted)}>{users.length} user{users.length !== 1 ? "s" : ""}</span>
        </div>

       
        {!isMobile && (
          <div style={{ overflowX: "auto" }}>
            <table style={styles.table}>
              <thead>
                <tr>
                  {["Name", "Email", "Mobile", "Role", "Permissions", "Actions"].map((h) => (
                    <th key={h} style={styles.th}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {currentRows.map((u) => {
                  const roleMeta = ROLE_META[u.role] || ROLE_META["user"];
                  // Safe processing of dynamic stringified or array data types fallback
                  const userPermsArray = typeof u.permissions === "string" ? JSON.parse(u.permissions || "[]") : (u.permissions || []);

                  return (
                    <tr key={u.id}>
                      <td style={{ ...styles.td, fontWeight: "600" }}>{u.name}</td>
                      <td style={{ ...styles.td, color: theme.textMuted }}>{u.email}</td>
                      <td style={{ ...styles.td, fontFamily: "monospace" }}>{u.mobile}</td>
                      <td style={styles.td}>
                        <span style={styles.badge(roleMeta.bg, roleMeta.color)}>
                          {roleMeta.label}
                        </span>
                      </td>
                      <td style={{ ...styles.td, maxWidth: "220px" }}>
                        <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
                          {userPermsArray.length === 0 ? (
                            <span style={{ fontSize: "12px", color: theme.textMuted, fontStyle: "italic" }}>No permissions</span>
                          ) : (
                            userPermsArray.slice(0, 4).map((p) => (
                              <span key={p} style={{ fontSize: "10px", padding: "2px 6px", backgroundColor: "#f1f5f9", borderRadius: "4px", border: `1px solid ${theme.border}`, color: theme.textMuted }}>
                                {p}
                              </span>
                            ))
                          )}
                          {userPermsArray.length > 4 && (
                            <span style={{ fontSize: "10px", padding: "2px 6px", backgroundColor: "#eff6ff", borderRadius: "4px", color: theme.primary, fontWeight: "600" }}>
                              +{userPermsArray.length - 4} more
                            </span>
                          )}
                        </div>
                      </td>
                      <td style={styles.td}>
                        <div style={{ display: "flex", gap: "6px" }}>
                          <button onClick={() => handleEdit(u)} style={styles.actionBtn()} title="Edit">
                            <Edit3 size={12} />
                          </button>
                          <button onClick={() => handleDelete(u.id)} style={{ ...styles.actionBtn(), color: theme.destructive }} title="Delete">
                            <Trash2 size={12} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
                {currentRows.length === 0 && (
                  <tr>
                    <td colSpan={6} style={{ ...styles.td, textAlign: "center", color: theme.textMuted, padding: "40px" }}>
                      No users created yet.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}

        {isMobile && (
          <div style={{ display: "flex", flexDirection: "column" }}>
            {currentRows.map((u) => {
              const roleMeta = ROLE_META[u.role] || ROLE_META["user"];
              const userPermsArray = typeof u.permissions === "string" ? JSON.parse(u.permissions || "[]") : (u.permissions || []);

              return (
                <div key={u.id} style={{ padding: "16px", borderBottom: `1px solid ${theme.border}`, display: "flex", flexDirection: "column", gap: "8px" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <p style={{ fontSize: "14px", fontWeight: "600", margin: 0 }}>{u.name}</p>
                    <span style={styles.badge(roleMeta.bg, roleMeta.color)}>{roleMeta.label}</span>
                  </div>
                  <p style={{ fontSize: "12px", color: theme.textMuted, margin: 0 }}>{u.email}</p>
                  <p style={{ fontSize: "12px", fontFamily: "monospace", margin: 0 }}>{u.mobile}</p>

                  <div style={{ display: "flex", flexWrap: "wrap", gap: "4px", paddingTop: "4px" }}>
                    {userPermsArray.slice(0, 3).map((p) => (
                      <span key={p} style={{ fontSize: "10px", padding: "2px 6px", backgroundColor: "#f1f5f9", borderRadius: "4px", color: theme.textMuted }}>{p}</span>
                    ))}
                    {userPermsArray.length > 3 && (
                      <span style={{ fontSize: "10px", padding: "2px 6px", backgroundColor: "#eff6ff", borderRadius: "4px", color: theme.primary }}>+{userPermsArray.length - 3}</span>
                    )}
                  </div>

                  <div style={{ display: "flex", gap: "8px", paddingTop: "6px" }}>
                    <button onClick={() => handleEdit(u)} style={{ ...styles.btnSecondary, flex: 1, padding: "6px", fontSize: "12px", display: "flex", alignItems: "center", justifyContent: "center", gap: "4px" }}>
                      <Edit3 size={11} /> Edit
                    </button>
                    <button onClick={() => handleDelete(u.id)} style={{ ...styles.btnSecondary, flex: 1, padding: "6px", fontSize: "12px", display: "flex", alignItems: "center", justifyContent: "center", gap: "4px", color: theme.destructive, borderColor: theme.border }}>
                      <Trash2 size={11} /> Delete
                    </button>
                  </div>
                </div>
              );
            })}
            {currentRows.length === 0 && (
              <div style={{ padding: "32px", textAlign: "center", color: theme.textMuted, fontSize: "12px" }}>
                No users created yet.
              </div>
            )}
          </div>
        )}

        <div style={{ ...styles.footerBar, flexDirection: isMobile ? "column" : "row", gap: "12px" }}>
          <p style={{ fontSize: "12px", color: theme.textMuted, margin: 0 }}>
            Showing {users.length === 0 ? 0 : startIndex + 1}–{Math.min(startIndex + itemsPerPage, users.length)} of {users.length}
          </p>
          <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
            <button
              onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
              disabled={currentPage === 1}
              style={{ ...styles.btnSecondary, padding: "6px", display: "flex", opacity: currentPage === 1 ? 0.4 : 1, cursor: currentPage === 1 ? "not-allowed" : "pointer" }}
            >
              <ChevronLeft size={14} />
            </button>
            {Array.from({ length: totalPages }, (_, i) => i + 1).map((p) => (
              <button
                key={p}
                onClick={() => setCurrentPage(p)}
                style={{
                  ...styles.btnSecondary,
                  padding: "0",
                  width: "28px",
                  height: "28px",
                  backgroundColor: currentPage === p ? theme.primary : "#fff",
                  color: currentPage === p ? "#fff" : theme.textMuted,
                  borderColor: currentPage === p ? theme.primary : theme.border
                }}
              >
                {p}
              </button>
            ))}
            <button
              onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
              disabled={currentPage === totalPages}
              style={{ ...styles.btnSecondary, padding: "6px", display: "flex", opacity: currentPage === totalPages ? 0.4 : 1, cursor: currentPage === totalPages ? "not-allowed" : "pointer" }}
            >
              <ChevronRight size={14} />
            </button>
          </div>
        </div>
      </div> */}
    </div>
  );
}

